(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function(){
  const wrap = document.currentScript.closest('.faq-wrap');
  if(!wrap) return;

  const grid = wrap.querySelector('.faq-grid');
  const items = Array.from(grid.querySelectorAll('details.faq-item'));

  /* Enforce SINGLE-OPEN — close others whenever one opens */
  items.forEach((d) => {
    d.addEventListener('toggle', () => {
      if (d.open) items.forEach(o => { if (o !== d) o.open = false; });
    });
  });

  /* On load: keep only the first open if multiple were saved */
  let firstSeen = false;
  items.forEach(d => {
    if (d.open && !firstSeen) { firstSeen = true; }
    else if (d.open && firstSeen) { d.open = false; }
  });

  /* Live search */
  const input = wrap.querySelector('input[type="search"]');
  const clear = wrap.querySelector('.faq-clear');
  function filter(){
    const q = (input?.value || '').toLowerCase().trim();
    items.forEach(d => {
      const t = d.querySelector('.faq-q__text')?.textContent.toLowerCase() || '';
      const a = d.querySelector('.faq-a')?.textContent.toLowerCase() || '';
      const match = !q || t.includes(q) || a.includes(q);
      d.style.display = match ? '' : 'none';
      if(!match) d.open = false;
    });
  }
  input?.addEventListener('input', filter);
  clear?.addEventListener('click', ()=>{ input.value=''; input.focus(); filter(); });
})();

  } catch(e) { console.error(e); }
})();
})();
